import { createFileRoute, Link } from "@tanstack/react-router";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Card, CardContent } from "@/components/ui/card";
import { readLastWorkspaceSearch } from "@/features/provider-workspace/workspace-last-search";
import { MonitoringPage } from "@/features/psv-monitoring/monitoring-page";
import { useOrganization } from "@/hooks/use-organization";
import { Permission, useRolePermissions } from "@/hooks/use-role-permissions";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/providers/credentials/settings/",
)({
  component: CredentialSettingsRoute,
});

function CredentialSettingsRoute() {
  const { user } = Route.useRouteContext();
  const { hasPermission } = useRolePermissions(user);
  const { selectedOrgBusinessUnit } = useOrganization();
  const organizationBusinessUnitId = selectedOrgBusinessUnit.id;
  const isAvailable =
    selectedOrgBusinessUnit.enablePrimarySourceVerification &&
    hasPermission(Permission.ViewProviderCredentials);
  return (
    <div className="space-y-6 p-4 md:p-6">
      <header className="space-y-4">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                {/* Returns to the roster with the filters it was left on. */}
                <Link
                  to="/org/bu/$organizationBusinessUnitId/providers/credentials"
                  params={{ organizationBusinessUnitId }}
                  search={readLastWorkspaceSearch(organizationBusinessUnitId)}
                >
                  Provider credentials
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Settings</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <h1 className="text-2xl font-semibold tracking-tight">
          Credential settings
        </h1>
      </header>
      {isAvailable ? (
        <MonitoringPage
          organizationBusinessUnitId={organizationBusinessUnitId}
          canEdit={hasPermission(Permission.EditProviderCredentials)}
        />
      ) : (
        <Card className="border-dashed">
          <CardContent className="p-8 text-center text-muted-foreground">
            Credential settings aren't available for this business unit or your
            role.
          </CardContent>
        </Card>
      )}
    </div>
  );
}
